'use client'

import Tracker from '@openreplay/tracker'
import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

export const openReplayTracker = new Tracker({
  projectKey: process.env.NEXT_PUBLIC_OPENREPLAY_PROJECT_KEY as string,
  ingestPoint: process.env.NEXT_PUBLIC_OPENREPLAY_INGEST_POINT,
  resourceBaseHref: process.env.NEXT_PUBLIC_OPENREPLAY_RESOURCE_BASE_HREF,
  network: {
    failuresOnly: false,
    capturePayload: true,
    ignoreHeaders: false,
    sessionTokenHeader: false,
    captureInIframes: false,
  },
})

export default function Openreplay() {
  const searchParams = useSearchParams()
  const testId = searchParams?.get('test_id')

  useEffect(() => {
    if (typeof window !== 'undefined') {
      openReplayTracker
        .start({
          metadata: {
            env: process.env.NEXT_PUBLIC_APP_ENV as string,
          },
        })
        .then(() => {})
    }
  }, [])

  useEffect(() => {
    if (testId) {
      openReplayTracker.setMetadata('testId', testId)
    }
  }, [testId])

  return null
}
